module.exports = __webpack_public_path__ + "img/pccontactus.a32c355e.svg";